import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propNumber, propShape, } from '../../../../../../../helpers/custom-prop-types';
import CharmPointRow from '../../CharmPoint/CharmPointRow';
const RightComponentPcCharmPoint = (props) => {
    const { charmPoint, charmPoints, driverTargetRef, isDisabled, onChangeCompleteInputRange, onChangeInputRange, onClickDriverTarget, } = props;
    return (_jsx("div", Object.assign({ className: 'inner_column full_screen_modal_right_range_column is_pc', onClick: onClickDriverTarget, ref: driverTargetRef, role: 'presentation' }, { children: _jsx(CharmPointRow, { bottomRowClassName: 'charmpoint_bottom_row_pc', charmPoint: charmPoint, charmPoints: charmPoints, isDisabled: isDisabled, label: _jsxs(_Fragment, { children: ["\u63D0\u6848", _jsx("br", {}), "\u9B45\u529B\u5EA6"] }), onChange: onChangeInputRange, onChangeComplete: onChangeCompleteInputRange, orientation: 'vertical', topRowClassName: 'charmpoint_top_row_pc' }) })));
};
RightComponentPcCharmPoint.propTypes = {
    charmPoint: propNumber().isRequired,
    charmPoints: propArrayShape().isRequired,
    driverTargetRef: propShape(),
    isDisabled: propBool().isRequired,
    onChangeCompleteInputRange: propFunc().isRequired,
    onChangeInputRange: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
};
RightComponentPcCharmPoint.defaultProps = {
    driverTargetRef: null,
    onClickDriverTarget: undefined,
};
export default RightComponentPcCharmPoint;
